import ArrowRight from "@/assets/images/icons/arrow-right-scroll.svg";
import React from "react";
import { TouchableOpacity } from "react-native";
import {
  HORIZONTAL_CAROUSEL_ARROW_BG,
  horizontalCarouselArrowShadowStyle,
} from "./constants";

type CarouselArrowButtonProps = {
  direction: "left" | "right";
  buttonSize: number;
  iconSize: number;
  onPress: () => void;
  /** StaticSection vertically centers arrows; full-width sections do not. */
  centered?: boolean;
};

export function CarouselArrowButton({
  direction,
  buttonSize,
  iconSize,
  onPress,
  centered = false,
}: CarouselArrowButtonProps) {
  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={onPress}
      style={{
        position: "absolute",
        left: direction === "left" ? 24 : undefined,
        right: direction === "right" ? 16 : undefined,
        ...(centered
          ? {
              top: "50%",
              transform: [{ translateY: -buttonSize / 2 }],
            }
          : {}),
        backgroundColor: HORIZONTAL_CAROUSEL_ARROW_BG,
        borderRadius: buttonSize / 2,
        width: buttonSize,
        height: buttonSize,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 3,
        ...horizontalCarouselArrowShadowStyle,
      }}
    >
      <ArrowRight
        height={iconSize}
        style={direction === "left" ? { transform: [{ scaleX: -1 }] } : undefined}
      />
    </TouchableOpacity>
  );
}
